import { z } from 'zod';

/**
 * Estados de `AsignacionSimulacion`. Sin casa en JC (`02_CONTRATOS.md` §6);
 * política de tolerancia en `02_CONTRATOS.md` §3.5.
 * Schema Zod laxo (`z.string()`) — el cliente tolera estados nuevos. Esta
 * lista es para narrowing opcional vía `isEstadoAsignacionConocido`.
 */
export const ESTADOS_ASIGNACION_CONOCIDOS = [
  'PENDIENTE',
  'EN_CURSO',
  'COMPLETADA',
  'CANCELADA',
  'VENCIDA',
] as const;
export type EstadoAsignacionConocido = (typeof ESTADOS_ASIGNACION_CONOCIDOS)[number];

export function isEstadoAsignacionConocido(value: string): value is EstadoAsignacionConocido {
  return (ESTADOS_ASIGNACION_CONOCIDOS as readonly string[]).includes(value);
}

export const EstadoAsignacionSchema = z.string();

/**
 * Estados de `Simulacion` (sin casa en JC; ver `02_CONTRATOS.md` §6). Schema
 * laxo + narrowing helper, mismo patrón P3 que los estados de asignación.
 *
 * **Nota cliente 2D:** `EN_EXAMEN` no debería verse — examen físico es
 * VR-only (R3). Si llega, el cliente trata la sesión como inválida y
 * vuelve a `/mi-simulacion`.
 */
export const ESTADOS_SIMULACION_CONOCIDOS = [
  'INICIADA',
  'EN_ENTREVISTA',
  'EN_EXAMEN',
  'COMPLETADA',
  'ABANDONADA',
  'ERROR',
] as const;
export type EstadoSimulacionConocido = (typeof ESTADOS_SIMULACION_CONOCIDOS)[number];

export function isEstadoSimulacionConocido(value: string): value is EstadoSimulacionConocido {
  return (ESTADOS_SIMULACION_CONOCIDOS as readonly string[]).includes(value);
}

export const EstadoSimulacionSchema = z.string();

/**
 * Códigos de `sesion.error` (JC §0.5). El contrato declara el catálogo
 * completo; aun así el schema es laxo para que un código futuro llegue al
 * cliente en vez de perderse en la validación. Tras cualquier código el
 * servidor cierra el socket. El texto al usuario sale del `codigo`, nunca
 * del `mensaje`.
 */
export const SESION_ERROR_CODIGOS_CONOCIDOS = [
  'no_autenticado',
  'ticket_invalido',
  'simulacion_cerrada',
  'reconexion_desde_otro_cliente',
  'sts_init_failed',
] as const;
export type SesionErrorCodigoConocido = (typeof SESION_ERROR_CODIGOS_CONOCIDOS)[number];

export function isSesionErrorCodigoConocido(value: string): value is SesionErrorCodigoConocido {
  return (SESION_ERROR_CODIGOS_CONOCIDOS as readonly string[]).includes(value);
}

export const SesionErrorCodigoSchema = z.string();
